import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useExploreFeedsFeedStore = defineSmartFeedPiniaStore(
  "explore-feeds-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/explore/feeds";
      },
    },
  },
);
